import { HttpClient } from "@angular/common/http";
import { Component, Input, OnInit, ViewEncapsulation } from "@angular/core";
import { UntypedFormControl, UntypedFormGroup } from "@angular/forms";
import { SearchFormBase } from "../../../../../components/common/search-form-base/search-form-base";
import { AppServiceHelperService } from "../../../../../services/app-service-helper.service";
import { EventBusService } from "../../../../../services/event-bus.service";

/**
 * Valuations search form
 */
@Component({
  selector: 'valuations-search-form',
  templateUrl: './valuations-search-form.component.html',
  styleUrls: ['./valuations-search-form.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ValuationsSearchFormComponent extends SearchFormBase<any> implements OnInit {

  /**
   * Selected item
   */
  @Input() selectedItem: any;

  /**
   * Input field selected description.
   */
  @Input() selectedDesc: any;

  /**
   * Selected item type
   */
  @Input() selectedItemType: any = null;

  /**
   * Search event handler (event bus)
   */
  protected get searchEventName(): string {
    return 'comparables.valuations.search';
  }

  /**
   * Show all event handler (event bus)
   */
  protected get showAllEventName(): string {
    return 'comparables.valuations.showAll';
  }

  /**
   * Gets the filter object
   * @param form
   * @returns
   */
  protected getFilterObject(form: UntypedFormGroup) {
    const filter = {
      logic: "and",
      filters: [],
      serverFilters: []
    };

    if (this.formData.controls.city.value) {
      filter.filters.push({ field: 'City', value: this.formData.controls.city.value, operator: "contains" });
    }
    if (this.formData.controls.postalCode.value) {
      filter.filters.push({ field: 'PostCode', value: this.formData.controls.postalCode.value, operator: "contains" });
    }
    if (this.formData.controls.street.value) {
      filter.filters.push({ field: 'Street', value: this.formData.controls.street.value, operator: "contains" });
    }
    if (this.selectedItemType === 'comparablesProperty') {
      filter.filters.push({ field: 'PropertyID', operator: 'eq', value: this.selectedItem?.Oid });
    }
    if (this.formData.controls.valuationDateFrom.value || this.formData.controls.valuationDateTo.value) {
      //<input type="date"> keeps value as yyyy-MM-dd (as required for serverValue), so use directly
      const fromDate = this.formData.controls.valuationDateFrom.value;
      const toDate = this.formData.controls.valuationDateTo.value;
      filter.filters.push({
        field: "ValuationDate",
        operator: "contains",
        value: this.formData.controls.valuationDateFrom.value + '-' + this.formData.controls.valuationDateTo.value,
        serverValue: `{ fromDate: '${fromDate}', toDate: '${toDate}' }`
      });
    }
    if (this.formData.controls.waltFrom.value || this.formData.controls.waltTo.value) {
      filter.filters.push({ field: "Walt", operator: "contains", value: this.formData.controls.waltFrom.value + '-' + this.formData.controls.waltTo.value, serverValue: "{ from: " + (this.formData.controls.waltFrom.value || "null") + ", to: " + (this.formData.controls.waltTo.value || "null") + " }" });
    }
    if (this.formData.controls.vacancyFrom.value || this.formData.controls.vacancyTo.value) {
      filter.filters.push({ field: "VacancyRate", operator: "contains", value: this.formData.controls.vacancyFrom.value + '-' + this.formData.controls.vacancyTo.value, serverValue: "{ from: " + (this.formData.controls.vacancyFrom.value || "null") + ", to: " + (this.formData.controls.vacancyTo.value || "null") + " }" });
    }

    return filter;
  }

  /**
   * Creates the FormGroup
   * @param data
   * @returns
   */
  protected createFormGroup(data: any): UntypedFormGroup {
    return new UntypedFormGroup({
      city: new UntypedFormControl(''),
      postalCode: new UntypedFormControl(''),
      street: new UntypedFormControl(''),
      valuationDateFrom: new UntypedFormControl(''),
      valuationDateTo: new UntypedFormControl(''),
      waltFrom: new UntypedFormControl(''),
      waltTo: new UntypedFormControl(''),
      vacancyFrom: new UntypedFormControl(''),
      vacancyTo: new UntypedFormControl('')
    });
  }

  /**
   * Resets the form
   */
  protected reset(): void {
    this.formData.controls['city'].setValue('');
    this.formData.controls['postalCode'].setValue('');
    this.formData.controls['street'].setValue('');
    this.formData.controls['valuationDateFrom'].setValue('');
    this.formData.controls['valuationDateTo'].setValue('');
    this.formData.controls['waltFrom'].setValue('');
    this.formData.controls['waltTo'].setValue('');
    this.formData.controls['vacancyFrom'].setValue('');
    this.formData.controls['vacancyTo'].setValue('');

    this.selectedItemType = null;
  }

  /**
   * Initializes the form data
   * @returns
   */
  protected initFormData(): Promise<any> {
    return new Promise<any>((resolve) => {
      const values = {
        city: '',
        postalCode: '',
        street: '',
        valuationDateFrom: '',
        valuationDateTo: '',
        waltFrom: '',
        waltTo: '',
        vacancyFrom: '',
        vacancyTo: ''
      };
      resolve(values);
    });
  }

  /**
   * Constructor
   * @param eventBus EventBusService
   * @param httpClient HttpClient
   * @param appServiceHelper AppServiceHelperService
   */
  constructor(eventBus: EventBusService, httpClient: HttpClient, appServiceHelper: AppServiceHelperService) {
    super(eventBus, httpClient, 'resetComparablesSearchForm', appServiceHelper);
  }

  /**
   * Initializes the component
   */
  ngOnInit(): void {
    this.init().then(() => {
      //Nothing
    });
  }
}
